import { CourseSlider, HomeRightSidebar, InstructorSlider } from "@components";
import { APP_TITLE_SUFFIX } from "@constants";
import {
  getHighestRatedCoursesAction,
  getNewestCoursesAction,
  getPopularInstructorAction,
} from "@redux/actions";
import { getAllMyLearningAction } from "@redux/modules/course/slices";
import clsx from "clsx";
import React, { Fragment, useEffect } from "react";
import { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import styles from "./styles/HomePage.module.css";

const HomePage = () => {
  // render

  // state

  // variables

  // logics before hooks

  // hooks
  const dispatch = useDispatch();
  const { highestRatedCourses, newestCourses, getAllMyLearning } = useSelector(
    (state) => state.course
  );
  const { getPopularInstructor, profile } = useSelector((state) => state.user);
  const { login } = useSelector((state) => state.auth);

  // logics
  const getNotEnrolledCourses = (originalData, size) => {
    return originalData
      ?.filter((any) => !any.isEnroll && any.user?.id !== profile.data?.id)
      .slice(0, size);
  };

  // UI partials

  // effects
  useEffect(() => {
    dispatch(getHighestRatedCoursesAction());
    dispatch(getNewestCoursesAction());
    dispatch(getPopularInstructorAction());
    dispatch(getAllMyLearningAction());
  }, [dispatch]);

  useLayoutEffect(() => {
    document.title = `Home | ${APP_TITLE_SUFFIX}`;
  }, []);

  // render
  return (
    <div className={clsx(styles.homePage, "container-fluid px-4")}>
      <div className="row my-4">
        <div className={"col-lg-9 col-md-12 mb-4"}>
          {login.isAuth && getAllMyLearning.data?.length ? (
            <Fragment>
              <div className="title d-flex justify-content-between mb-3">
                <h4>Your Learning</h4>
                <Link to="/my-learning" className={styles.link}>
                  See all <i className="bi bi-arrow-right-short" />
                </Link>
              </div>
              <div className="mb-3">
                <CourseSlider
                  data={getAllMyLearning.data?.slice(0, 10)}
                  loading={getAllMyLearning.processing}
                  courseType="learn"
                />
              </div>
            </Fragment>
          ) : null}
          <div className="title d-flex justify-content-between mb-3">
            <h4>Highest Rated Courses</h4>
            <Link to="/explore?Orderby=avgRate+desc" className={styles.link}>
              See all <i className="bi bi-arrow-right-short" />
            </Link>
          </div>
          <div className="mb-3">
            <CourseSlider
              data={getNotEnrolledCourses(highestRatedCourses.data, 10)}
              loading={highestRatedCourses.processing}
            />
          </div>
          <div className="title d-flex justify-content-between mb-3">
            <h4>Newest Courses</h4>
            <Link to="/explore" className={styles.link}>
              See all <i className="bi bi-arrow-right-short" />
            </Link>
          </div>
          <div className="mb-3">
            <CourseSlider
              data={getNotEnrolledCourses(newestCourses.data, 10)}
              loading={newestCourses.processing}
            />
          </div>
          <div className="title d-flex justify-content-between mb-3">
            <h4>Popular Instructors</h4>
            <Link to="/all-instructors" className={styles.link}>
              See all <i className="bi bi-arrow-right-short" />
            </Link>
          </div>
          <div className="mb-3">
            <InstructorSlider
              data={getPopularInstructor.data?.slice(0, 5)}
              loading={getPopularInstructor.processing}
            />
          </div>
        </div>
        <div className="col-lg-3 col-md-12 mb-3">
          <HomeRightSidebar />
        </div>
      </div>
    </div>
  );
};

/* required: display name */
HomePage.displayName = "HomePage";

/* required: props types */
HomePage.propTypes = {};

/* required: default props */
HomePage.defaultProps = {};

export { HomePage };
